import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Logo from "./Logo";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0D0D0D]">
        <div className="opacity-60 animate-pulse">
          <Logo size="md" />
          <div className="text-center mt-4 text-xs tracking-[0.3em] text-[#9A9590] uppercase">
            Authenticating
          </div>
        </div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
